(async () => {

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('main-header-sticky', class extends baseComponent.default {
        // The header turns sticky once this 50vh sentinel scrolls away. A section further down
        // that sticks just under the header - the product pages' Buy Now / Features bar, pinned
        // at top: var(--nav-height) by its template CSS - can dock before that on a tall window,
        // leaving an empty strip where the header belongs. So the header is also sticky while
        // any such section is docked.
        render() {
            this.pastSentinel = false;
            this.docked = new Set();
            this.observers = [];

            let frame;
            const rewatch = () => {
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(() => this._watchDocking());
            };
            window.addEventListener('resize', rewatch);
            const main = document.getElementById('MainContent');
            // The theme editor adds, removes and re-renders sections without a page load.
            if (main) new MutationObserver(rewatch).observe(main, { childList: true });
            this._watchDocking();
        }

        onIntersect(intersecting) {
            this.pastSentinel = !intersecting;
            this._update();
        }

        _update() {
            const sticky = this.pastSentinel || this.docked.size > 0;
            if (sticky === this.sticky) return;
            this.sticky = sticky;
            this.trigger('stickyMainHeader', { sticky });
        }

        // A docked section's own box never leaves the viewport, so watch the section above it
        // instead: once that has scrolled up past the docking line, the sticky one has docked.
        _watchDocking() {
            this.observers.forEach(observer => observer.disconnect());
            this.observers = [];
            this.docked.clear();

            const main = document.getElementById('MainContent');
            const header = document.querySelector('main-header');
            if (main && window.IntersectionObserver) {
                Array.from(main.children).forEach(section => {
                    const style = getComputedStyle(section);
                    const above = section.previousElementSibling;
                    if (style.position !== 'sticky' || !above) return;
                    // `top` is still auto until main-header.js has set --nav-height, which it sets
                    // to the header's height less 1px.
                    const top = parseFloat(style.top);
                    const line = isNaN(top) ? Math.max((header ? header.offsetHeight : 0) - 1, 0) : top;
                    const observer = new IntersectionObserver(([entry]) => {
                        // Out of view below the fold is not docked; only gone past the top is.
                        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                            this.docked.add(above);
                        } else {
                            this.docked.delete(above);
                        }
                        this._update();
                    }, { rootMargin: `-${line}px 0px 0px 0px` });
                    observer.observe(above);
                    this.observers.push(observer);
                });
            }
            // New observers report their first state themselves. Updating before that would
            // drop a docked header for a frame and replay its slide-in on every resize.
            if (!this.observers.length) this._update();
        }
    })
})();
